import React from 'react';
import { motion } from 'framer-motion';
import { UserIcon } from './icons';

interface NavigationProps {
  onUserClick: () => void;
  onHomeClick: () => void;
  userStats?: {
    tryOnCount: number;
    allowedTryOnCount: number;
    isSubscribed: boolean;
  } | null;
}

const Navigation: React.FC<NavigationProps> = ({
  onUserClick,
  onHomeClick,
  userStats
}) => {
  const remainingAttempts = userStats ? Math.max(0, userStats.allowedTryOnCount - userStats.tryOnCount) : 0;

  return (
    <nav className="bg-white shadow-lg sticky top-0 z-40">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <motion.button
            onClick={onHomeClick}
            className="flex items-center gap-2 text-2xl font-bold text-purple-600"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <span className="text-3xl">👗</span>
            <span>Style Me</span>
          </motion.button>

          {/* Action Buttons */}
          <div className="flex items-center gap-4">
            {/* Credits Display */}
            {userStats && (
              <div className="hidden md:flex flex-col items-end mr-4">
                <span className="text-xs text-gray-500 uppercase font-bold tracking-wider">Attempts</span>
                <span className={`text-lg font-bold leading-none ${remainingAttempts === 0 ? 'text-red-500' : 'text-purple-900'}`}>
                  {remainingAttempts} / {userStats.allowedTryOnCount}
                </span>
              </div>
            )}

            {/* User */}
            <button
              onClick={onUserClick}
              className="p-2 text-gray-700 hover:text-purple-600 transition-colors flex items-center gap-2"
              title="My Account"
            >
              <span className="hidden md:inline font-medium">My Account</span>
              <UserIcon className="w-6 h-6" />
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
